module.exports = __webpack_public_path__ + "img/collection-weddingRingsForestGreen@2x.0fb2a58.webp";